import { Button, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ActiveDeactivateButton = ({ activationStatus, handleOnClick }) => {
	const theme = useTheme();

	return (
		<Tooltip title={activationStatus === 'Active' ? 'Deactivate' : 'Activate'}>
			<Button
				type="button"
				sx={{
					py: '5px',
					color: '#fff',
					fontSize: '13px',
					lineHeight: '22px',
					fontWeight: '500',
					borderRadius: '4px',
					transition: 'all 0.1s',
					backgroundColor: activationStatus === 'Active' ? theme.palette.lynTheme.delete : theme.palette.lynTheme.success,

					'&:hover': {
						backgroundColor: activationStatus === 'Active' ? theme.palette.lynTheme.delete : theme.palette.lynTheme.success,
						transform: 'scale(1.05)',
					},
				}}
				onClick={handleOnClick}
			>
				{activationStatus === 'Active' ? 'Deactivate' : 'Activate'}
			</Button>
		</Tooltip>
	);
};

export default ActiveDeactivateButton;
